"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NestedError extends Error {
    constructor(message, innerError) {
        super(message);
        if (Error.captureStackTrace !== undefined) {
            Error.captureStackTrace(this, NestedError);
        }
        this.innerError = innerError;
    }
}
exports.NestedError = NestedError;
function nestError(message, innerError) {
    return new NestedError(message, innerError);
}
exports.nestError = nestError;
//# sourceMappingURL=nested-error.js.map